<template>
  <v-layout
    align-space-around
    justify-space-around
    column
  >
    <v-flex
      align-start
      justify-start
    >
      <h4
        class="text-xs-left"
        @click="commentToggle"
      >
        {{ strings.comments }}
        <v-icon
          v-if="showComments"
          color="text"
        >
          mdi-chevron-up
        </v-icon>
        <v-icon
          v-if="!showComments"
          color="text"
        >
          mdi-chevron-down
        </v-icon>
      </h4>
    </v-flex>
    <div v-if="showComments">
      <v-flex
        v-for="(comment, index) in comments"
        :key="index"
      >
        <v-card class="comment-card">
          <v-container>
            <v-layout column>
              <v-flex v-if="comment.commentString">
                <h3 class="comment-title">
                  {{ comment.commentString }}
                </h3>
              </v-flex>
              <v-flex v-if="comment.comment">
                <h3 class="comment-title">
                  {{ comment.comment }}
                </h3>
              </v-flex>
              <v-divider dark />
              <v-flex>
                <v-layout row>
                  <v-flex>
                    <p class="comment meta">
                      {{ displayDate(comment.date) }}
                    </p>
                  </v-flex>
                  <v-flex>
                    <p class="comment meta">
                      {{ comment.username }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </div>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  props: ["comments"],
  data() {
    return {
      showComments: false
    };
  },
  computed: {
    ...mapGetters("page", ["strings"])
  },
  methods: {
    displayDate(dateString) {
      let date = new Date(dateString);
      return date.toLocaleDateString();
    },
    commentToggle() {
      this.showComments = !this.showComments;
      this.$emit("setComments", this.showComments);
    }
  }
};
</script>

<style scoped>
.comment-card {
  background-color: #00000020;
  margin-top: 1vh;
  margin-bottom: 1vh;
}

p.comment.meta {
  margin-bottom: -2vh;
}
.comment-title {
  margin-bottom: 2vh;
}
</style>
